<template>
  <div class="content">
    <top></top>
    <div class="projectContent" :class="{'en':language!=='zh'}">
      <div class="banner">
        <div class="banner_img"></div>
        <div class="textBox clearfix">
          <div class="left">
            <p class="title1">{{$t('project.项目对接')}}</p>
            <p
              class="title2"
            >{{$t('project.创意内容供应和服务端与需求端双向对接，专业和产业链协同协作对接。')}}</p>
            <p class="title3">{{$t('project.MANA平台提供免费发布和自主匹配服务。')}}</p>
          </div>
          <!-- <a
            href="http://manabang.mikecrm.com/C6pgP4g"
            target="_bank"
            class="right"
          >{{$t('project.发布项目')}}</a>-->
        </div>
      </div>
      <div class="nav">
        <div class="navBox">
          <span class="active">{{$t('project.找供应商')}}</span>
          <span @click="gotoType(2)">{{$t('project.找项目')}}</span>
          <span @click="gotoType(3)">{{$t('project.参考案例')}}</span>
        </div>
      </div>
      <div class="subProject">
        <div class="buttomBox clearfix">
          <a class="left" href="http://manabang.mikecrm.com/g4yVMM9" target="_bank">
            <p class="title1">{{$t('project.找全案服务')}}</p>
            <p class="title2">{{$t('project.咨询-方案-资源-落地-运营')}}</p>
            <i></i>
          </a>
          <a class="right" href="http://manabang.mikecrm.com/saEzDEm" target="_bank">
            <p class="title1">{{$t('project.找专业服务')}}</p>
            <p class="title2">{{$t('project.咨询顾问、策划策展、创意创作、软硬件及工程技术、项目运营')}}</p>
            <i></i>
          </a>
        </div>
        <div class="platformTypeBg">
          <div class="platformType">
            <div class="category clearfix">
              <div class="left">
                <div class="leftBox">
                  <p class="title1">{{$t('project.专业平台，精准资源')}}</p>
                  <p
                    class="title2"
                  >{{$t('project.MANA是全球艺术与科技创意内容分享与市场转化的专业平台；是新媒体艺术领域最具影响力的行业媒体之一。')}}</p>
                </div>
              </div>
              <div class="right">
                <img src="https://image.manamana.net/web_feature_1@2x.png" alt />
              </div>
            </div>
            <div class="category clearfix">
              <div class="right">
                <img src="https://image.manamana.net/web_feature_2@2x.png" alt />
              </div>
              <div class="left">
                <div class="leftBox">
                  <p class="title1">{{$t('project.对接海量全球创作者资源')}}</p>
                  <p
                    class="title2"
                  >{{$t('project.您将有机会对接到覆盖全球80%国家和地区的创作团队，合作领域涉及文旅、商业地产、医疗健康、休闲娱乐、科技教育等，助您找到最合适的创作者。')}}</p>
                </div>
              </div>
            </div>
            <div class="category clearfix">
              <div class="left">
                <div class="leftBox">
                  <p class="title1">{{$t('project.免费推广机会')}}</p>
                  <p class="title2">{{$t('project.在MANA对接成功的项目，有机会获得平台免费推广资源。')}}</p>
                </div>
              </div>
              <div class="right">
                <img src="https://image.manamana.net/web_feature_3@2x.png" alt />
              </div>
            </div>
          </div>
        </div>
        <div class="release">
          <div class="applicationType">
            <p class="title1">
              <img src="https://image.manamana.net/web_title_dot@2x.png" alt />
              {{$t('project.应用场景')}}
            </p>
            <div class="applicationBox clearfix">
              <div
                class="application"
                :class="'application' + (i+1)"
                @mouseenter="isActive=i"
                @mouseleave="isActive=null"
                v-for="(item,i) in caseLists"
                :key="i"
                v-if="i <= 4"
              >
                <div class="titleName" :class="{'active':isActive==i}">{{language == 'zh'?item.category:item.enCategory}}</div>
                <div class="app-content" :class="{'active':isActive==i}">
                  <p
                    class="tag"
                    v-for="(data,y) in item.items"
                    :key="y"
                    @click="gotoCase1(i,y)"
                    target="_blank"
                    v-if="y < 5"
                  >{{language == 'zh'?data.category:data.enCategory}}</p>
                  <div class="whole" @click="gotoCase2(i)">
                    {{$t('project.查看全部案例')}}
                    <img src="https://image.manamana.net/web_arrow.png" alt />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="service">
            <p class="title">
              <img src="https://image.manamana.net/web_title_dot@2x.png" alt />
              {{$t('project.服务流程')}}
            </p>
            <div class="clearfix">
              <div class="serviceType">
                <div class="box">
                  <img src="https://image.manamana.net/web_service_step_1@2x.png" alt />
                </div>
                <p class="type">
                  <img class="number" src="https://image.manamana.net/num1@2x.png" alt />
                  {{$t('project.提交需求')}}
                  <img
                    class="arrow"
                    src="https://image.manamana.net/web_step_arrow@2x.png"
                    alt
                  />
                </p>
              </div>
              <div class="serviceType">
                <div class="box">
                  <img src="https://image.manamana.net/web_service_step_2@2x.png" alt />
                </div>
                <p class="type">
                  <img class="number" src="https://image.manamana.net/num2@2x.png" alt />
                  {{$t('project.审核发布')}}
                  <img
                    class="arrow"
                    src="https://image.manamana.net/web_step_arrow@2x.png"
                    alt
                  />
                </p>
                <p class="title1">
                  <span>*</span>
                  {{$t('project.项目需求需要与科技艺术领域相关。审核结果将会在1个工作日内以邮件形式告知您。')}}
                </p>
              </div>
              <div class="serviceType">
                <div class="box">
                  <img src="https://image.manamana.net/web_service_step_3@2x.png" alt />
                </div>
                <p class="type">
                  <img class="number" src="https://image.manamana.net/num3@2x.png" alt />
                  {{$t('project.对接资源')}}
                </p>
                <p class="title1">
                  <span>*</span>
                  {{$t('project.创作者的投递信息将以系统邮件形式发送到您的邮箱，需求发布后请注意查收邮件。')}}
                </p>
              </div>
            </div>
          </div>
          <div class="other">
            <p class="title1">{{$t('project.其它服务')}}</p>
            <p class="title2">{{$t('project.商务客服邮箱')}} <a href="mailto:business@manamana.net">business@manamana.net</a></p>
            <p class="title3">
              <i>*</i>
              {{$t('project.此服务为收费服务，按推荐/提供团队信息的数量收费，推荐/提供团队信息收费199元，或者可以购买年费服务。年度服务收费999元（全年推荐不超过20个团队）')}}
            </p>
          </div>
          <!-- <a
            href="http://manabang.mikecrm.com/C6pgP4g"
            target="_bank"
            class="subJect"
          >{{$t('project.发布项目')}}</a>-->
        </div>
        <div class="fixedBox" v-if="isShowFixed">
          <div class="box clearfix">
            <a
              class="left"
              href="http://manabang.mikecrm.com/g4yVMM9"
              target="_bank"
            >{{$t('project.找全案服务')}}</a>
            <a
              class="right"
              href="http://manabang.mikecrm.com/saEzDEm"
              target="_bank"
            >{{$t('project.找专业服务')}}</a>
          </div>
        </div>
      </div>
    </div>
    <!-- <footer-down class="searchFooter" v-if="type!=1"></footer-down> -->
  </div>
</template>
<script>
import top from "@/components/v2/Header.vue";
import FooterDown from "@/components/v2/Footer.vue";

export default {
  name: "platform",
  metaInfo() {
    return {
      title: this.$t("global.项目对接") + " | MANA",
    };
  },
  filters: {
    budgetStatus(item) {
      let text = "";
      let status = item.budget;
      if (status == "") {
        return this.$t("project.暂无");
      }
      for (let i = 0; i < status.length; i++) {
        if (!status[i].indexOf("1")) {
          text = text.concat("3万以下");
        }
        if (!status[i].indexOf("2")) {
          text = text.concat("3-10万");
        }
        if (!status[i].indexOf("3")) {
          text = text.concat("10-20万");
        }
        if (!status[i].indexOf("4")) {
          text = text.concat("20-50万");
        }
        if (!status[i].indexOf("5")) {
          text = text.concat("50-100万");
        }
        if (!status[i].indexOf("6")) {
          text = text.concat("100万以上");
        }
        if (!status[i].indexOf("7")) {
          text = text.concat(item.customerBudget);
        }
      }
      return text;
    },
  },
  data() {
    return {
      typeIndex: 1,
      isActive: null,
      lists: [],
      caseLists: [],
      isShowFixed: false,
    };
  },
  components: {
    top,
    FooterDown,
  },
  created() {
    // this.bulletin();
    this.getCaseList();
    this.buriedPoint(21,0)
  },
  computed: {
    language() {
      return this.$language();
    }
  },
  mounted() {
    window.addEventListener("scroll", this.showIcon);
  },
  watch: {
    $route(to) {
      window.addEventListener("scroll", this.showIcon);
    },
  },
  methods: {
    gotoType(type) {
      if (type==2) {
        this.$router.push('/takeProject')
      }
      if (type==3) {
        this.$router.push('/caseProject')
      }
    },
    showIcon() {
      if (
        document.documentElement.scrollTop &&
        document.documentElement.scrollTop > 836
      ) {
        this.isShowFixed = true;
      } else {
        this.isShowFixed = false;
      }
    },
    timeEnd(time) {
      var timestamp = new Date().getTime();
      if (timestamp > time) {
        return false;
      } else {
        return true;
      }
    },
    bulletin() {
      this.$http.post("/api/project/list").then((res) => {
        if (res.code === "OK") {
          this.lists = res.data.list;
        }
      });
    },
    getCaseList() {
      this.$http.get("/api/common/page?id=3328&type=1").then((res) => {
        if (res.code === "OK") {
          const arr = res.data.body.match(/<code>(.*)<\/code>/);
          if (arr.length === 2) {
            const data = arr[1]
              .replace(/"/g, "`")
              .replace(/&quot;/g, '"')
              .replace(/&amp;/g, '&')
              .replace(/<[^a][^((?!\/a).)*][^>]*>/g, "");
            this.caseLists = JSON.parse(data);
          }
        }
      });
    },
    takeProject(item) {
      let routeData = this.$router.resolve({ path: "/projectDetails" });
      window.open(routeData.href, "_blank");
      // this.$router.push("/projectDetails");
      localStorage.setItem("takeItem", JSON.stringify(item));
    },
    subVideo() {
      // this.$router.push("/UpVideo");
      let routeData = this.$router.resolve({ path: "/UpVideo" });
      window.open(routeData.href, "_blank");
    },
    gotoCase1(i, y) {
      // this.typeIndex = i + 1;
      // let name = "caseTop" + y;
      // this.$nextTick(() => {
      //   document.getElementsByClassName(name)[0].scrollIntoView();
      // });
      this.$router.push({path:'/caseProject',query:{'type':i+1,'name':'caseTop'+y}})
    },
    gotoCase2(i) {
      // this.typeIndex = i + 1;
      // this.$nextTick(() => {
      //   document.getElementsByClassName('typeNav')[0].scrollIntoView();
      // });
      this.$router.push({path:'/caseProject',query:{'type':i+1,'name':'typeNav'}})
    },
  },
};
</script>

<style lang="stylus" scoped>
.projectContent {
  background: #fff;
  padding-bottom: 120px;

  .banner {
    width: 100%;
    height: 300px;
    position: relative;
    overflow: hidden;

    .banner_img {
      width: 100%;
      height: 300px;
      background: url('https://image.manamana.net/1599718652025_KRrqZwKl');
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
      display: inline-block;
    }

    .textBox {
      width: 1110px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);

      .left {
        float: left;
        width: 658px;

        .title1 {
          font-size: 40px;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
        }

        .title2 {
          font-size: 14px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          margin-top: 36px;
          line-height: 36px;
        }

        .title3 {
          font-size: 14px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 36px;
        }
      }

      .right {
        float: right;
        width: 160px;
        height: 50px;
        line-height: 50px;
        background: #4E40EB;
        box-shadow: 0px 1px 4px 0px rgba(23, 3, 79, 0.3), 0px 2px 4px 0px rgba(23, 3, 79, 0.3);
        border-radius: 2px;
        text-align: center;
        font-size: 18px;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        margin-top: 57px;
      }
    }
  }

  .nav {
    min-width: 1110px;
    height: 70px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);

    .navBox {
      width: 1110px;
      margin: 0 auto;

      span {
        display: inline-block;
        font-size: 20px;
        font-weight: 600;
        color: rgba(10, 10, 10, 1);
        height: 70px;
        line-height: 70px;
        box-sizing: border-box;
        margin-right: 70px;
        cursor: pointer;
      }

      span.active {
        border-bottom: 4px solid rgba(78, 64, 235, 1);
      }
    }
  }

  .subProject {
    position: relative;
    padding-bottom: 100px;

    .buttomBox {
      width: 1110px;
      margin: 0 auto;
      padding: 70px 0 80px 0;

      .left {
        float: left;
        width: 540px;
        height: 150px;
        background: linear-gradient(315deg, #2C34FF 0%, #A2A5FD 100%);
        border-radius: 8px;
        position: relative;

        .title1 {
          font-size: 34px;
          font-weight: 600;
          color: #FFFFFF;
          line-height: 50px;
          margin: 32px 0 12px 60px;
        }

        .title2 {
          font-size: 16px;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 24px;
          margin: 0 80px 0 60px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        i {
          background: url('https://image.manamana.net/web_top_btn_arrow@2x.png') no-repeat;
          background-size: 100% 100%;
          width: 20px;
          height: 36px;
          position: absolute;
          right: 40px;
          top: 57px;
        }
      }

      .right {
        float: right;
        width: 540px;
        height: 150px;
        background: linear-gradient(316deg, #4E40EB 0%, #C1A5FF 100%);
        border-radius: 8px;
        position: relative;

        .title1 {
          font-size: 34px;
          font-weight: 600;
          color: #FFFFFF;
          line-height: 50px;
          margin: 32px 0 12px 60px;
        }

        .title2 {
          font-size: 16px;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 24px;
          margin: 0 80px 0 60px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        i {
          background: url('https://image.manamana.net/web_top_btn_arrow@2x.png') no-repeat;
          background-size: 100% 100%;
          width: 20px;
          height: 36px;
          position: absolute;
          right: 40px;
          top: 57px;
        }
      }
    }

    .platformTypeBg {
      background: #FAFAFA;
      padding-top: 70px;

      .platformType {
        width: 980px;
        margin: 0 auto 70px;

        .title1 {
          font-size: 24px;
          font-weight: 400;
          color: #333;
          margin-bottom: 60px;
          text-align: center;

          img {
            width: 30px;
            height: 30px;
            margin-right: 12px;
            vertical-align: bottom;
          }
        }

        .category {
          margin-bottom: 40px;

          .left {
            vertical-align: middle;
            width: 605px;
            display: table-cell;

            .leftBox {
              width: 475px;
              margin: 0 65px;

              .title1 {
                font-size: 30px;
                font-weight: 600;
                color: rgba(51, 51, 51, 1);
                text-align: left;
                margin: 0 0 30px 0;
              }

              .title2 {
                font-size: 18px;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
                line-height: 28px;
              }
            }
          }

          .right {
            display: table-cell;
            vertical-align: middle;
            width: 440px;
            height: 350px;

            img {
              width: 440px;
              height: 350px;
            }
          }
        }
      }
    }

    .release {
      width: 1110px;
      margin: 0 auto;

      .applicationType {
        margin-bottom: 140px;

        .title1 {
          font-size: 24px;
          font-weight: 400;
          color: #333;
          margin: 60px 0;
          text-align: center;

          img {
            width: 30px;
            height: 30px;
            margin-right: 12px;
            vertical-align: bottom;
          }
        }

        .applicationBox {
          width: 100%;

          .application {
            position: relative;
            float: left;
            width: 218px;
            height: 342px;
            padding: 0 24px;
            box-sizing: border-box;
            margin-right: 5px;

            .titleName {
              font-size: 26px;
              font-weight: bold;
              color: #333;
              margin-top: 20px;
              margin-bottom: 30px;
            }

            .app-content {
              display: none;

              .tag {
                font-size: 16px;
                color: #333;
                margin-bottom: 16px;
                cursor: pointer;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;

                &:hover {
                  color: rgba(78, 64, 235, 1);
                  font-weight: bold;
                }
              }

              .whole {
                position: absolute;
                bottom: 32px;
                text-align: center;
                width: 158px;
                height: 34px;
                line-height: 34px;
                font-weight: 500;
                font-size: 14px;
                color: #fff;
                background: rgba(78, 64, 235, 0.85);
                border-radius: 17px;
                cursor: pointer;

                img {
                  width: 11px;
                  height: 19px;
                  vertical-align: text-bottom;
                }
              }

              &.active {
                display: block;
              }
            }
          }

          .application1 {
            background: url('https://image.manamana.net/web_scene_1_bg@2x.png') no-repeat;
            background-size: 100% 100%;
          }

          .application2 {
            background: url('https://image.manamana.net/web_scene_2_bg@2x.png') no-repeat;
            background-size: 100% 100%;
          }

          .application3 {
            background: url('https://image.manamana.net/web_scene_3_bg@2x.png') no-repeat;
            background-size: 100% 100%;
          }

          .application4 {
            background: url('https://image.manamana.net/web_scene_4_bg@2x.png') no-repeat;
            background-size: 100% 100%;
          }

          .application5 {
            background: url('https://image.manamana.net/web_scene_5_bg@2x.png') no-repeat;
            background-size: 100% 100%;
          }

          .application:nth-child(5) {
            margin-right: 0;
          }
        }
      }

      .service {
        width: 980px;
        margin: 0 auto 100px;

        .title {
          font-size: 24px;
          font-weight: 400;
          color: #333;
          margin-bottom: 60px;
          text-align: center;

          img {
            width: 30px;
            height: 30px;
            margin-right: 12px;
            vertical-align: bottom;
          }
        }

        .serviceType {
          float: left;
          width: 280px;
          margin-right: 70px;

          .box {
            width: 280px;
            height: 200px;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .type {
            font-size: 26px;
            font-weight: 500;
            color: #333;
            text-align: center;
            margin: 20px 0;
            position: relative;

            img.number {
              width: 26px;
              height: 37px;
              vertical-align: bottom;
              margin-right: 10px;
            }

            img.arrow {
              position: absolute;
              bottom: 0;
              right: -45px;
              width: 20px;
              height: 36px;
            }
          }

          .title1 {
            span {
              font-size: 14px;
              font-weight: 600;
              color: rgba(254, 86, 48, 1);
            }

            font-size: 14px;
            font-weight: 400;
            color: #999;
            line-height: 24px;
          }
        }

        .serviceType:nth-child(3) {
          margin-right: 0;
        }
      }

      .other {
        width: 1110px;
        height: 160px;
        background: #FAFAFA;
        border-radius: 4px;
        padding-top: 33px;
        box-sizing: border-box;

        .title1 {
          font-size: 18px;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
          text-align: center;
        }

        .title2 {
          text-align: center;
          font-size: 14px;
          font-weight: 400;
          color: #666;
          margin: 16px 0 8px 0;
        }

        .title3 {
          text-align: center;
          font-size: 14px;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);

          i {
            font-weight: 600;
            color: rgba(254, 86, 48, 1);
          }
        }
      }

      .subJect {
        display: inline-block;
        width: 280px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        background: linear-gradient(135deg, #6F93FE 0%, #4E40EB 100%);
        box-shadow: 0px 1px 2px 0px rgba(32, 5, 97, 0.08), 0px 2px 4px 0px rgba(32, 5, 97, 0.1);
        border-radius: 2px;
        margin-left: 50%;
        transform: translateX(-50%);
        font-size: 20px;
        font-weight: 500;
        color: #FFFFFF;
        margin-top: 100px;
      }
    }

    .fixedBox {
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 100px;
      background: #FFFFFF;
      box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);

      // z-index: 999;
      .box {
        width: 760px;
        margin: 20px auto;

        .left {
          width: 350px;
          height: 60px;
          line-height: 60px;
          text-align: center;
          background: linear-gradient(135deg, #A2A5FD 0%, #2C34FF 100%);
          box-shadow: 0px 1px 2px 0px rgba(32, 5, 97, 0.08), 0px 2px 4px 0px rgba(32, 5, 97, 0.1);
          border-radius: 2px;
          float: left;
          font-size: 20px;
          font-weight: 600;
          color: #FFFFFF;
        }

        .right {
          width: 350px;
          height: 60px;
          line-height: 60px;
          text-align: center;
          background: linear-gradient(135deg, #C1A5FF 0%, #4E40EB 100%);
          box-shadow: 0px 1px 2px 0px rgba(32, 5, 97, 0.08), 0px 2px 4px 0px rgba(32, 5, 97, 0.1);
          border-radius: 2px;
          float: right;
          font-size: 20px;
          font-weight: 600;
          color: #FFFFFF;
        }
      }
    }
  }

  .meetProject {
    .Settlement {
      width: 100%;
      height: 56px;
      background: rgba(32, 38, 204, 0.1);
      margin-bottom: 60px;

      .SettlementBox {
        width: 1110px;
        margin: 0 auto;

        .icon {
          width: 36px;
          height: 36px;
          float: left;
          background: url('https://image.manamana.net/web_icon_mana_creators@2x.png') no-repeat;
          background-size: 100% 100%;
          margin-top: 10px;
        }

        .title {
          float: left;
          height: 56px;
          line-height: 56px;

          .title1 {
            font-size: 16px;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
          }

          .title2 {
            font-size: 14px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            margin: 0 12px;
          }

          .title3 {
            font-size: 14px;
            font-weight: 500;
            color: #4E40EB;
            cursor: pointer;

            img {
              width: 16px;
              height: 16px;
              vertical-align: text-top;
            }
          }
        }
      }
    }

    .module {
      width: 1110px;
      margin: 0 auto;

      .moduleBox {
        float: left;
        width: 350px;
        height: 295px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(224, 224, 224, 1);
        margin: 0 30px 50px 0;
        box-sizing: border-box;
        cursor: pointer;

        .top {
          width: 350px;
          height: 160px;
          padding: 28px 20px 0;
          box-sizing: border-box;
          background: url('https://image.manamana.net/web_project_bg@2x.png');
          background-position: center center;
          background-repeat: no-repeat;
          background-size: cover;

          .title1 {
            width: 310px;
            margin-bottom: 12px;
            line-height: 32px;
            font-size: 24px;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          .title2 {
            width: 310px;
            line-height: 24px;
            font-size: 15px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }

        .title3 {
          font-size: 14px;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          margin-top: 20px;
          width: 305px;
          margin-left: 20px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-word;
        }

        .title4 {
          font-size: 14px;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          margin: 8px 0 18px 20px;

          img {
            width: 10px;
            height: 13px;
            display: inline-block;
          }
        }

        .title5 {
          font-size: 14px;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          margin-left: 20px;
          line-height: 30px;

          .price {
            font-size: 16px;
            font-weight: 600;
            color: rgba(252, 98, 64, 1);
          }

          .button1 {
            float: right;
            width: 110px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background: rgba(32, 38, 204, 1);
            font-size: 14px;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
            margin-right: 20px;
          }

          .button2 {
            float: right;
            width: 110px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background: #B8B8B8;
            font-size: 14px;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
            margin-right: 20px;
          }
        }
      }

      .moduleBox:nth-child(3n) {
        margin-right: 0;
      }
    }
  }

  .selected {
    width: 1110px;
    margin: 0 auto;

    .typeNav {
      border-bottom: 1px solid #E0E0E0;
      height: 70px;
      line-height: 70px;
      margin-bottom: 50px;

      span {
        font-size: 18px;
        height: 70px;
        line-height: 70px;
        color: rgba(102, 102, 102, 1);
        display: inline-block;
        margin-right: 70px;
        box-sizing: border-box;
        cursor: pointer;
      }

      span.active {
        font-weight: 600;
        color: #4E40EB;
        border-bottom: 3px solid #4E40EB;
      }
    }

    .caseBox {
      .case1 {
        margin-bottom: 30px;

        .title {
          font-size: 20px;
          font-weight: 300;
          color: rgba(51, 51, 51, 1);
          margin-bottom: 24px;
        }

        .case {
          .caseBox1 {
            width: 540px;
            height: 304px;
            position: relative;
            float: left;
            margin-right: 30px;
            margin-bottom: 30px;
            .caseImg {
              width: 100%;
              height: 100%;
            }

            .caseTitle {
              position: absolute;
              width: 480px;
              left: 30px;
              bottom: 28px;

              .title1 {
                font-size: 24px;
                font-weight: bold;
                color: rgba(255, 255, 255, 1);
              }

              .title2 {
                font-size: 20px;
                font-weight: 600;
                color: rgba(255, 255, 255, 1);
                margin: 20px 0 12px 0;
              }

              .title3 {
                font-size: 14px;
                font-weight: 400;
                color: rgba(255, 255, 255, 1);

                .avact {
                  width: 24px;
                  height: 24px;
                  display: inline-block;
                  border-radius: 50%;
                  margin-right: 8px;
                }
              }
            }
          }

          .caseBox1:nth-child(2n) {
            margin-right: 0;
          }
        }
      }
    }
  }

  &.en {
    .banner .textBox .left {
      .title1 {
        font-size: 44px;
      }
      .title2, .title3 {
        font-size: 16px;
      }
    }

    .nav .navBox span {
      font-size: 18px;
    }

    .subProject .buttomBox .left .title1, .subProject .buttomBox .right .title1 {
      font-size: 30px;
      margin-bottom: 4px;
    }

    .subProject .buttomBox .left .title2, .subProject .buttomBox .right .title2 {
      font-size: 14px;
    }

    .subProject .platformTypeBg .platformType .category .left .leftBox .title1 {
      margin-bottom: 20px;
    }

    .subProject .platformTypeBg .platformType .category .left .leftBox .title2 {
      font-size: 16px;
    }

    .subProject .release .applicationType .applicationBox .application .titleName {
      font-size: 20px;
      height: 56px;
      margin-bottom: 20px;
    }

    .subProject .release .applicationType .applicationBox .application .app-content .tag {
      font-size: 14px;
      margin-bottom: 14px;
    }

    .subProject .release .service .serviceType .type img.number {
      vertical-align: -10px;
    }

    .subProject .release .service .serviceType .type {
      font-size: 20px;
    }

    .subProject .release .service .serviceType .title1 {
      margin-left: 30px;
    }

    .selected .typeNav span {
      font-size: 16px;
    }
  }
}

.searchFooter {
  position: relative !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/project/project.vue